import {Fragment} from "react";
import TitleProject from "./TitleProject";

const ProjectDescription = ({description, linkProject}) => {
    return(
        <div className="bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300">
            <div className="space-y-6">
                <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-slate-900 dark:bg-slate-400 rounded-full"></div>
                    <h2 className="text-2xl font-bold text-slate-900 dark:text-white transition-colors duration-300">
                        Project Description
                    </h2>
                </div>
                
                <div className="prose prose-slate max-w-none">
                    <p 
                        style={{whiteSpace: "pre-line"}} 
                        className="text-slate-700 dark:text-slate-400 leading-relaxed text-lg font-light transition-colors duration-300"
                    >
                        {description}
                    </p>
                </div>
                
                {linkProject && (
                    <div className="pt-4">
                        <a 
                            href={linkProject} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="group inline-flex items-center gap-2 bg-slate-900 hover:bg-slate-800 dark:bg-slate-100 dark:hover:bg-white text-white dark:text-slate-900 font-semibold py-3 px-6 rounded-xl transition-all duration-300 shadow-sm"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                            </svg>
                            <span>View Live Project</span>
                            <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                            </svg>
                        </a>
                    </div>
                )}
                
                {!linkProject && (
                    <div className="pt-4">
                        <div className="inline-flex items-center gap-2 bg-slate-200 text-slate-500 font-semibold py-3 px-6 rounded-xl cursor-not-allowed">
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L5.636 5.636m4.242 4.242L15.12 15.12" />
                            </svg>
                            <span>Project Link Not Available</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}
export default ProjectDescription;